export const UPDATE_PANEL_PROPERTIES = 'UPDATE_PANEL_PROPERTIES';
export const HIDE_PRIMARY_PANEL = 'HIDE_PRIMARY_PANEL';
export const SHOW_PRIMARY_PANEL = 'SHOW_PRIMARY_PANEL';
export const TOGGLE_PRIMARY_PANEL_COMPACT = 'TOGGLE_PRIMARY_PANEL_COMPACT';
export const HIDE_SECONDARY_PANEL = 'HIDE_SECONDARY_PANEL';
export const SHOW_SECONDARY_PANEL = 'SHOW_SECONDARY_PANEL';
export const TOGGLE_SECONDARY_PANEL_COMPACT = 'TOGGLE_SECONDARY_PANEL_COMPACT';